import { OhVueIcon, addIcons } from './raw/Icon';
import { PLEASED_ICON_DATA } from './icons/pleased-icons.data';

/**
 * Registers only inlined icon payloads (see ./icons/pleased-icons.data.ts).
 * Do not import `oh-vue-icons/icons/*` here — Webpack 4 ships whole pack files; see README.md.
 */
export const OhVuePlugin: Vue.PluginFunction<never> = (app) => {
  addIcons(...PLEASED_ICON_DATA);
  app.component('VIcon', OhVueIcon);
};
